import { useContext } from 'react';
import { cultureContext } from '../contexts';

/**
 * Returns stored language, culture settings, financial settings and timezone identification.
 *
 * @returns Language, culture settings, financial settings and timezome identification.
 * @example
  const { language, culture, financialSet, timeZone } = useCulture();
 */
export function useCulture() {
  return useContext(cultureContext);
}
//# sourceMappingURL=useCulture.js.map